<div class="flex flex-col gap-3">
  <span
    class="bg-red-4 font-roboto-500 text-16 rounded-5 p-5 text-grey-1 max-sm:text-13 max-sm:p-3"
  >
    {{ this.title() }}
  </span>
  <div class="flex justify-between gap-5">
    <div class="flex flex-col flex-grow gap-5">
      @for(record of this.homeLineUp(); track record.Id) {
      <app-lineup-player [lineUpPlayer]="record" />
      }
    </div>
    <div class="flex flex-col flex-grow gap-5">
      @for(record of this.awayLineUp(); track record.Id) {
      <app-lineup-player [lineUpPlayer]="record" [isRTL]="true" />
      }
    </div>
  </div>
</div>
